<template>
  <div class="body-report">
    <!-- 统计信息 -->
    <div class="stats">
      <div class="stat-item warning">
        <div class="stat-label">{{ $t('charts.elements.needAttention') }}</div>
        <div class="stat-value">
          <span class="number">{{ warningCount }}</span>/{{ totalCount }}
        </div>
      </div>
      <div class="stat-item qualified">
        <div class="stat-label" style="color: #003BBF;">{{ $t('charts.elements.excellentIndicator') }}</div>
        <div class="stat-value">
          <span class="number">{{ qualifiedCount }}</span>/{{ totalCount }}
        </div>
      </div>
    </div>

    <!-- 身体数据列表 -->
    <div class="body-list">
      <div
          v-for="(item, index) in items"
          :key="index"
          class="body-item"
          @click="$emit('item-click', item)"
      >
        <img class="name-icon" :src="`/assets/bodyImg/${item.code}.png`" alt="">
        <div class="item-name-container">
          <div class="item-name">{{ item.name }}</div>
          <div class="item-name-en">{{ item.nameEn || item.item_dict_name_en || '' }}</div>
        </div>
        <div class="item-progress">
          <div class="progress-bar">
            <div
                class="progress-fill"
                :style="{ 
                  width: getProgressWidth(item.value), 
                  backgroundColor: getProgressColor(item.value) 
                }"
            ></div>
          </div>
        </div>

        <div class="">
          <div class="status-btn"
               :class="[getTextWrapperClass(item.value),{ active: isPositive(item.value), 'english-btn': $i18n.locale === 'en-US' }]">

            <!--              {{item.value}}-->
            <span class="text-status">{{ bodyState(item.value) }}</span>
            <img v-if="item.value < -1" src="../assets/感叹号.png" alt="" class="warning-icon">
            <img v-if="item.value > 1" src="../assets/赞.png" alt="" class="excellent-icon">
            <img v-if="item.value >= -1 && item.value <= 1 && item.value <= 0" src="../assets/减号.png" alt="" class="minus-icon">
            <img v-if="item.value >= -1 && item.value <= 1 && item.value > 0" src="../assets/加号.png" alt="" class="plus-icon">
          </div>

          <!--            <div class="text-wrapper_4 flex-col positive-value"-->

          <!--                 v-if="item.value >= -4 && item.value < -1"-->
          <!--                 :class="{ active: isPositive(item.value) }">-->
          <!--              <span class="text_14">关注</span>-->
          <!--            </div>-->
          <!--            <div class="text-wrapper_5-13 flex-col"-->
          <!--                 v-if="item.value >= -1 && item.value <= 1"-->
          <!--            >-->
          <!--              <span class="text_6">良好</span>-->
          <!--            </div>-->
          <!--            <div class="text-wrapper_5-1 flex-col"-->
          <!--                 v-if="item.value > 1 && item.value <= 4"-->
          <!--            >-->
          <!--              <span class="text_6">优秀</span>-->
          <!--            </div>-->
        </div>

        <div class="item-arrow">
          <img src="../assets/进入@2x.png" alt="" class="arrow-icon">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "BodyReportCard",
  data: () => {
    return {}
  },

  props: {
    // 卡片标题
    title: {
      type: String,
      default: "身体综合数据报告"
    },
    // 数据项
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },

  computed: {
    warningCount() {
      return this.items.filter(item => item.value < -1).length;
    },

    qualifiedCount() {
      return this.items.filter(item => item.value >= -1).length;
    },

    totalCount() {
      return this.items.length;
    },
    bodyState() {
      return (value) => {
        if (value < -1) return this.$t('charts.elements.attention')
        if (value <= 1) return this.$t('health.status.average')
        return this.$t('charts.elements.excellent')
      }
    },
    getTextWrapperClass() {
      return (value) => {
        if (value < -1) return 'attention'
        if (value <= 1) {
          if (value <= 0) return 'good negative'
          return 'good positive'
        }
        return 'excellent'
      }

    }

  },

  methods: {
    getProgressWidth(value) {
      if (value < 0) {
        return `${Math.max(0, Math.min(100, (1 - (value + 4) / 4) * 100))}%`;
        // 负值范围：-4 到 0 映射到 0% 到 100%
        // return `${Math.max(0, Math.min(100, (value + 4) / 4 * 100))}%`;
      } else {
        // 正值范围：0 到 4 映射到 0% 到 100%
        return `${Math.max(0, Math.min(100, value / 4 * 100))}%`;
      }
    },


    getProgressColor(value) {
      // 负值为红色，正值为蓝色
      if (value < -1){
        return '#FF5C4D'
      } else if (value >= -1 && value <= 1){
        // 达标状态统一显示蓝色
        return '#1D8AFF'
      } else if (value > 1) {
        return '#003CBF'
      }
    },

    isNegative(value) {
      return value < 0;
    },

    isPositive(value) {
      return value >= 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.name-icon {
  width: 40px;

  height: 40px;
  margin-right: 10px;
}

.status-btn {
  border-radius: 30px;
  margin-left: 20px;
  width: 90px;
  height: 36px;
  line-height: 38px;
  text-align: center;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;

  /* 英文版本字体优化 */
  &:lang(en) {
    font-size: 18px;
    width: 110px;
  }
  
  &.english-btn {
    font-size: 18px;
    width: 110px;
  }
}

.attention {
  background-color: transparent;
  border: 1px solid #FF5C4D;
  color: #FF5C4D;
}

.good {
  background-color: transparent;
  border: 1px solid #1D8AFF;
  color: #1D8AFF;
}

.excellent {
  background-color: transparent;
  border: 1px solid #003CBF;
  color: #003CBF;;
}


.text-status {
  //display: block;
  //font-weight: 400;
  //font-size: 22px;
  //color: #1D8AFF;
  //text-align: center;

}

.warning-icon {
  width: 18px;
  height: 18px;
  margin-left: 4px;
  object-fit: contain;
  flex-shrink: 0;
  display: inline-block;
}

.excellent-icon {
  width: 18px;
  height: 18px;
  margin-left: 4px;
  object-fit: contain;
  flex-shrink: 0;
  display: inline-block;
}

.minus-icon {
  width: 12px;
  height: 12px;
  margin-left: 4px;
  object-fit: contain;
  flex-shrink: 0;
  display: inline-block;
  align-self: flex-start;
  margin-top: 6px;
}

.plus-icon {
  width: 12px;
  height: 12px;
  margin-left: 4px;
  object-fit: contain;
  flex-shrink: 0;
  display: inline-block;
  align-self: flex-start;
  margin-top: 8px;
}

.body-report {
  background-color: #F5F5F5;
  border-radius: 8px;
  padding: 20px;

  .stats {
    display: flex;
    justify-content: space-around;
    margin-bottom: 30px;
    margin-top: 30px;

    .stat-item {
      text-align: center;

      .stat-label {
        font-size: 23px;
        font-weight: 400;
        color: #FF5B4D;
        margin-bottom: 5px;
      }

      .stat-value {
        font-size: 28px;

        .number {
          font-size: 46px;
          font-weight: bold;
        }
      }

      &.warning .number {
        color: #FF5B4D;
      }

      &.qualified .number {
        color: #003BBF;
      }
    }
  }

  .body-list {
    .body-item {
      display: flex;
      align-items: center;
      padding: 18px 0;
      margin-top: 10px;
      height: 50px;

      &:last-child {
        border-bottom: none;
      }

      .item-name-container {
        flex-shrink: 0;
        display: flex;
        width: 140px;
        flex-direction: column;
        justify-content: center;
      }

      .item-name {
        width: 140px;
        font-weight: 400;
        font-size: 24px;
        color: #00133D;
        flex-shrink: 0;
        padding-right: 10px;
      }

      .item-name-en {
        font-size: 20px;
        color: #959FB7;
        font-weight: 400;
        line-height: 1.2;
      }

      .item-progress {
        flex: 1;
        padding: 0 4px;


        .progress-bar {
          height: 6px;
          width: 100%;
          background-color: #F0F0F0;
          border-radius: 3px;
          overflow: hidden;

          .progress-fill {
            height: 100%;
          }
        }
      }

      .item-values {
        width: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        margin-left: 20px;
        flex-shrink: 0;

        .divider {
          color: #959FB7;
          margin: 0 8px;
          font-weight: 400;
        }

        .negative-value, .positive-value {
          color: #959FB7;
          width: 70px;
          font-size: 25px;
          text-align: center;

          &.active {
            font-weight: bold;
          }
        }

        .negative-value {
          text-align: right;

          &.active {
            color: #FF5B4D;
            font-size: 30px;
          }
        }

        .positive-value {
          text-align: left;

          &.active {
            color: #003CBF;
            font-size: 30px;
          }
        }
      }

      .item-arrow {
        width: 40px;
        height: 40px;
        text-align: center;
        color: #959FB7;
        font-size: 24px;
        flex-shrink: 0;

        .arrow-icon {
          width: 40px;
          height: 40px;
          margin-left: 15px;
        }
      }

    }
  }

}
</style>